<script>
import Layout from '@layouts/main'

import moment from 'moment';
import LineChart from '@components/LineChart';
import {AxiosHelper} from '@src/utils/utils';


/**
 * Dashboard-1 Component
 */
export default {
	components: { Layout, LineChart },
  data() {
    return {
			// user: getLoggedInUser(),
			chineseUrl : process.env.VUE_APP_CHINESE,
			musicCount : {
				TJ : 0,
				KY : 0,
				fileTJ : 0,
				fileKY : 0
			},
			payment : {
				labels : [],
				datasets : []
			},
			chineseWordCount : 0,
			vmmStatus : 0
    }
	},
	created() {
		// AxiosHelper.get('/api/nas/vmm').then(ret => {
		// 	let vmmStatus = 0;
		// 	ret.data.guests.forEach(function(guest) {
		// 		if(guest.status === 'running')
		// 			vmmStatus++;
		// 	});
		// 	this.vmmStatus = vmmStatus;
		// });
		AxiosHelper.get('/api/music/count').then(ret => {
			const musicCount = {};
			for(const item of ret.data) {
				musicCount[item.media] = item.cnt;
			}
			this.musicCount = musicCount;
		});

		const today = moment();
		const start = moment().add(-3, 'months').startOf('month').format('x');
		const end = today.endOf('month').format('x');	

		AxiosHelper.get(`/api/cardsms/pay/history/${start}/${end}`).then(ret => {
			const data = ret.data;
			const months = {};
			const shopping = {};

			for(const item of data) {
				const mm = moment(item.time).format('MM월');
				if(!months[mm]) {
					months[mm] = 0;
				}
				if(!shopping[mm]) {
					shopping[mm] = 0;
				}

				months[mm] += item.price.toInt();
				if(item.category === 5) {
					shopping[mm] += item.price.toInt();
				}
			}


			this.payment = {
				labels : Object.keys(months).reverse(),
				datasets : [
					{
						label: '총 지출 금액',
						backgroundColor: 'rgba(75,192,192,0.4)',
						borderColor: 'rgba(75,192,192,1)',
						pointBorderColor: 'rgba(75,192,192,1)',
						pointBackgroundColor: '#fff',
						data: Object.values(months).reverse()
					},
					{
						label: '쇼핑',
						backgroundColor: 'rgba(246,255,0,0.4)',
						borderColor: 'rgba(246,255,0,1)',
						data: Object.values(shopping).reverse()
					},
				]
			};
		});

		AxiosHelper.get('/api/edu/chinese/0?notin=delete').then(ret => {
			const data = ret.data;
			this.chineseWordCount = data.length;
		});
	}
}
</script>

<template>
  <Layout>
		<C.PageHeader title="Dashboard"/>

		<C.Row>
			<C.Col lg="6" xs="12">
				<router-link tag="a" to="/spend/calendar">
					<div class="card-box">
						<line-chart :chart-data="payment" :height="200"/>
					</div>
				</router-link>
			</C.Col>
			<!-- <C.Col lg="3" xs="6">
				<router-link tag="a" to="/etc/vmm">
					<div class="card-box">
						<h4 class="mt-0 font-16">실행중인 OS </h4>
						<h2 class="text-primary my-3 text-center"><span data-plugin="counterup">{{vmmStatus}}</span>개</h2>
						<p class="text-muted mb-0">&nbsp;</p>
					</div>
				</router-link>
			</C.Col> -->
			<C.Col lg="3" xs="6">
				<a :href="chineseUrl" target="_blank" rel="noopener noreferrer">
					<div class="card-box">
						<h4 class="mt-0 font-16">등록된 중국어</h4>
						<h2 class="text-primary my-3 text-center"><span data-plugin="counterup">{{chineseWordCount.toComma()}}</span>건</h2>
						<p class="text-muted mb-0">&nbsp;</p>
					</div>
				</a>
			</C.Col>
			<C.Col lg="3" xs="6">
				<router-link tag="a" to="/music/book">
					<div class="card-box">
						<h4 class="mt-0 font-16">TJ </h4>
						<h2 class="text-primary my-3 text-center"><span data-plugin="counterup">{{musicCount.TJ.toComma()}}</span>건</h2>
						<p class="text-muted mb-0"> Files : {{musicCount.fileTJ.toComma()}}</p>
					</div>
				</router-link>
			</C.Col>
			<C.Col lg="3" xs="6">
				<router-link tag="a" to="/music/book">
					<div class="card-box">
						<h4 class="mt-0 font-16">KY </h4>
						<h2 class="text-primary my-3 text-center"><span data-plugin="counterup">{{musicCount.KY.toComma()}}</span>건</h2>
						<p class="text-muted mb-0"> Files : {{musicCount.fileKY.toComma()}}</p>
					</div>
				</router-link>
			</C.Col>

		</C.Row>

  </Layout>
</template>
